import apiClient from './api'
import type { ApiOrder, CreateOrderDto, UpdateOrderDto } from '@/types/api-order'

/**
 * Servicio para manejar operaciones de órdenes
 */
export const orderService = {
  /**
   * Obtener las órdenes del usuario autenticado
   */
  async getAll(): Promise<ApiOrder[]> {
    const response = await apiClient.get<ApiOrder[]>('/api/orders')
    return response.data
  },

  /**
   * Obtener todas las órdenes (admin) — requiere rol admin
   */
  async getAllAdmin(): Promise<ApiOrder[]> {
    const response = await apiClient.get<ApiOrder[]>('/api/orders/all')
    return response.data
  },

  /**
   * Obtener una orden por ID
   */
  async getById(id: number): Promise<ApiOrder> {
    const response = await apiClient.get<ApiOrder>(`/api/orders/${id}`)
    return response.data
  },

  /**
   * Crear una nueva orden
   */
  async create(order: CreateOrderDto): Promise<ApiOrder> {
    
    const response = await apiClient.post<ApiOrder>('/api/orders', order)
    return response.data
  },

  /**
   * Actualizar una orden existente
   */
  async update(id: number, order: UpdateOrderDto): Promise<ApiOrder> {
    const response = await apiClient.put<ApiOrder>(`/api/orders/${id}`, order)
    return response.data
  },

  async updateStatus(id: number, status: string): Promise<ApiOrder> {
    const response = await apiClient.patch<ApiOrder>(`/api/orders/${id}/status`, { status })
    return response.data
  },

  /**
   * Obtener resumen de órdenes no enviadas
   */
  async getNotSentSummary(): Promise<{ total_quantity: number }> {
    const response = await apiClient.get<{ total_quantity: number }>('/api/orders/not-sent-summary')
    return response.data
  },

  /**
   * Eliminar una orden
   */
  async delete(id: number): Promise<void> {
    await apiClient.delete(`/api/orders/${id}`)
  },
}


